import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
}

export default function usePageMeta(meta: PageMeta) {
  useEffect(() => {
    if (meta.title) {
      document.title = meta.title;
    }
    if (meta.description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", meta.description);
    }
  }, [meta.title, meta.description]);
}